<script lang="ts" setup>
	import BaseModal from '@/components/modals/BaseModal.vue';
	import {useI18n} from 'vue-i18n';

	const {t} = useI18n();

	const props = defineProps<{
		week: number;
		year: number;
	}>();

	const emits = defineEmits<{
		(e: 'close'): void,
		(e: 'confirm', currentWeekYear: { week: number, year: number }): void
	}>();

	const cancel = () => {
		emits('close');
	};

	const confirm = () => {
		emits('confirm', {week: props.week, year: props.year});
	};

</script>

<template>
	<base-modal cancel-button-text="" confirm-button-text="Continue" @cancel="cancel" @confirm="confirm">
		<template v-slot:title>
			{{ t('shoppingcart.modal.addmore.title') }}
		</template>

		<p>
			{{ t('shoppingcart.modal.addmore.prefix.text') }}
			<strong style="text-transform: lowercase">{{ t('shoppingcart.generic.week.text') }} {{ week }}</strong>.
		</p>
	</base-modal>
</template>
